import { Button, styled } from '@mui/material';
import { getBasicActionStyling } from '../../Popover.utils';

export const ActionSetContainer = styled(Button)(({ theme }) => ({
  ...getBasicActionStyling(theme)
}));
